import { render } from "./eduResearch.vue?vue&type=template&id=2d7c4b7f&scoped=true"
import script from "./eduResearch.vue?vue&type=script&lang=js"
export * from "./eduResearch.vue?vue&type=script&lang=js"

import "./eduResearch.vue?vue&type=style&index=0&id=2d7c4b7f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7c4b7f"]])

export default __exports__